export default __webpack_public_path__ + "static/media/favicon.3c326067.svg";